<!-- src/components/yuyue/modals/LoadingIndicator.vue -->
<template>
  <div class="modal" :class="{ active: isVisible }">
    <div class="modal-content" style="text-align: center;">
      <div class="loading-spinner"></div>
      <p style="margin-top: 20px;">{{ message }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingIndicator',
  props: {
    message: {
      type: String,
      default: '数据加载中...'
    }
  },
  data() {
    return {
      isVisible: false
    }
  },
  methods: {
    show() {
      this.isVisible = true;
    },
    hide() {
      this.isVisible = false;
    }
  }
}
</script>

<style scoped>
.loading-spinner {
  border: 4px solid rgba(26, 115, 232, 0.2);
  border-top: 4px solid #1a73e8;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>